import { useEffect, useState, MouseEvent, ChangeEvent } from 'react';
import GridComponent from '../../../component/grid/GridComponent.component';
import Table from '../../../component/table/Table.component';
import { useSnackbar } from '../../../context/Snackbar';
import { Pagination } from '../../../component/table/interfaces/Pagination';
import { Action, ACTION_EDIT_SUBMIT, ACTION_DELETE, ACTION_EDIT } from '../../../component/table/interfaces/TableInterface';
import useModal from '../../../hooks/useModal';
import Modal from '../../../component/modal/Modal.component';
import ModalDelete from '../../../component/modal/ModalDelete.component';
import { UserStore } from './interfaces/UserStore';
import ButtonFormFullWithLoading from '../../../component/buttton/ButtonFormFullWithLoading.component';
import { INITIAL_VALUES } from './utils/INITIAL_VALUES';
import Form from './form/Form.component';
import { getUserStore, deleteUserStore, putUserStore, postUserStore } from './UserStore.service';
import { HEAD_CELL } from './utils/HEAD_CELL';
import { compare } from '../../../utils/order/compare';
import SelectSearch, { IOption } from '../../../component/select/SelectSearch';
import { useStore } from '../../../context/Store';
import { IFlag } from '../../store/utils/Flags';
import { Grid } from '@material-ui/core';
import { getByStore, getStores } from '../../store/Store.service';
import StoreList from '../../store/interfaces/Store';
import { AxiosError } from 'axios';
import FormLabelComponent from '../../../component/input/FormLabel.component';
import { FormInput } from '../../../component/input/InputStyle';
import ButtonComponent from '../../../component/buttton/Button.component';

interface IPayload {
  store_id?: string;
  flag_id?: string;
  user_ad?: string;
  user_name?: string;
}
const defaultOption = {
  label: '',
  value: '',
};
const UserStoreComponent = () => {
  const { arrayFlags } = useStore();

  const { setSnackbar } = useSnackbar();
  const [request, setRequest] = useState<boolean>(true);
  const [loadingAD, setLoadingAD] = useState<boolean>(true);
  const [canSave, setCanSave] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);

  const [userStore, setUserStore] = useState<UserStore[]>([]);
  const [selectStore, setSelectStore] = useState<IOption>(defaultOption);
  const [selectFlag, setSelectFlag] = useState<IOption>(defaultOption);
  const [searchUser, setSearchUser] = useState<string>('');
  const [listStore, setListStore] = useState<Array<{ label: string; value: string }>>([]);
  const [total, setTotal] = useState<number>(0);
  const [pagination, setPagination] = useState<Pagination>({
    lastPage: 1,
    page: 1,
    sort: 'store_id',
    order: 1,
  });
  const [open, addModal] = useModal();
  const [openEdit, addModalEdit] = useModal();
  const [editData, setEditData] = useState<UserStore>();

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPagination({ ...pagination, page: newPage + 1 });
  };

  const handleRequestSort = (_event: MouseEvent<unknown>, property: string) => {
    const isAsc = pagination.sort === property && pagination.order === 1;
    setPagination({ ...pagination, sort: property, order: isAsc ? -1 : 1 });
  };

  const handleClickAction = (action: Action, userStore: UserStore) => {
    if (action === ACTION_EDIT_SUBMIT) {
      return registerUserStore(userStore);
    }

    if (action === ACTION_EDIT) {
      setEditData(userStore);
      return addModalEdit(userStore.id);
    }

    if (action === ACTION_DELETE) {
      return addModal(userStore.id);
    }
  };

  const getData = async (payload: IPayload) => {
    if (payload.store_id || payload.flag_id || payload.user_ad || payload.user_name) {
      const params = {
        page: pagination.page,
        store_id: payload.store_id,
        flag_id: payload.flag_id,
        user_ad: payload.user_ad,
        user_name: payload.user_name,
      };

      if (payload.user_name) {
        setSelectFlag(defaultOption);
        setSelectStore(defaultOption);
      }
      setRequest(true);
      await getUserStore(params)
        .then(async (response) => {
          if (response.data.data) {
            setUserStore(response.data.data);
            setTotal(response.data.total);
          }
          setRequest(false);
        })
        .catch((err) => {
          setRequest(false);
          console.log(err);
          setSnackbar({ msg: `Erro ao coletar novos dados`, type: 'error' });
        });
    } else {
      setUserStore([]);
      setTotal(0);
      setRequest(false);
    }
  };

  useEffect(() => {
    getData({
      flag_id: selectFlag.value,
      store_id: selectStore.value,
      user_name: searchUser,
    });
  }, [pagination]);

  const registerUserStore = async (userStore: UserStore) => {
    try {
      setSaving(true);
      await (userStore.id ? putUserStore(userStore) : postUserStore(userStore));
      setSnackbar({
        msg: `Vinculo foi ${userStore.id ? 'atualizado' : 'cadastrado'} com sucesso!`,
        type: 'success',
      });
      addModal(false);
      addModalEdit(false);
      setSaving(false);
      if (userStore.selectFlag && userStore.selectStore) {
        setSelectFlag(userStore.selectFlag);
        setSelectStore(userStore.selectStore);
        getData({
          flag_id: userStore.selectFlag.value,
          store_id: userStore.selectStore.value,
        });
      }
    } catch (error) {
      console.log('Erro ao submeter vinculo!', error);
      setSnackbar({
        msg: `Erro ao ${userStore.id ? 'atualizar' : 'cadastrar'} vinculo!`,
        type: 'error',
      });
      setSaving(false);
    }
  };

  const handleClickDelete = async () => {
    setRequest(true);
    await deleteUserStore(Number(open))
      .then((res) => {
        setSnackbar({ msg: 'Vinculo excluído com sucesso!', type: 'success' });
        getData({
          flag_id: selectFlag.value,
          store_id: selectStore.value,
          user_name: searchUser,
        });
      })
      .catch((error) => {
        console.log('Erro ao excluir vinculo!', error);
        setRequest(false);
        setSnackbar({ msg: 'Erro ao excluir vinculo!', type: 'error' });
      })
      .finally(function () {
        addModal(undefined);
      });
  };

  const formatArrayFlags = (): IOption[] => {
    const flagsOptions: IOption[] = [];

    arrayFlags.forEach((a: IFlag) => {
      flagsOptions.push({ label: String(a.flag), value: a.id });
    });

    return flagsOptions;
  };

  const filter = (store: StoreList[]): IOption[] => {
    let storeAux: IOption[] = [];
    store.map((el: StoreList) => {
      storeAux.push({
        label: el.Loja.id,
        value: el.Loja.id,
      });
      return el;
    });
    return storeAux;
  };

  const getStorebtFlag = async () => {
    if (selectFlag.value) {
      setRequest(true);
      await getStores(selectFlag.value)
        .then((res) => {
          if (res.data) {
            setListStore(filter(res.data as any));
          }
        })
        .catch((error: AxiosError) => {
          setRequest(false);
          console.log(error.response?.data);
          console.log(error);
          setSnackbar({
            msg: 'Erro ao consultar lojas da bandeira!',
            type: 'error',
          });
        })
        .finally(() => {
          setRequest(false);
        });
    }
  };

  useEffect(() => {
    getStorebtFlag();
  }, [selectFlag]);

  const handleChangeFlag = async (selectOption: IOption) => {
    setUserStore([]);
    setSelectStore({ label: '', value: '' });
    setSearchUser('');

    if (selectOption) {
      setSelectFlag(selectOption);
      await getData({ flag_id: selectOption.value });
    } else {
      setSelectFlag({ label: '', value: '' });
    }
  };

  const handleChangeStore = async (selectOption: IOption) => {
    setSearchUser('');
    setUserStore([]);

    if (selectOption) {
      setSelectStore(selectOption);
      getData({ flag_id: selectFlag.value, store_id: selectOption.value });
    } else {
      setSelectStore({ label: '', value: '' });
      getData({ flag_id: selectFlag.value });
    }
  };

  // useEffect(() => {
  //   setLoadingAD(true);
  //   setCanSave(false);
  //   setSaving(false);
  // }, [openEdit]);

  const filterUserStore = () => {
    const users = userStore.sort((a: any, b: any) => compare(a, b, pagination.sort || 'id', pagination.order));
    if (searchUser) {
      return users.filter((user) => user.name && user.name.toLowerCase().includes(searchUser.toLowerCase()));
    }
    return users;
  };

  return (
    <>
      <Grid container justifyContent='flex-start' alignItems='flex-end' spacing={2}>
        <SelectSearch title='Bandeira' data={formatArrayFlags()} onChange={(event: any, selectOption: any) => handleChangeFlag(selectOption)} placeholder='Selecione...' value={selectFlag} request={request} sm={12} md={6} lg={3} />

        <SelectSearch title='Loja' data={listStore} onChange={(event: any, selectOption: any) => handleChangeStore(selectOption)} placeholder='Selecione...' value={selectStore} request={request} sm={12} md={6} lg={3} disabled={!selectFlag.value} />

        <FormLabelComponent title='Usuário' sm={12} md={6} lg={3}>
          <FormInput
            name='user_name'
            placeholder='Digite para pesquisar'
            value={searchUser}
            onChange={(e: ChangeEvent<any>) => {
              setSearchUser(e.target.value ? e.target.value : '');
            }}
            inputProps={{ maxLength: 60 }}
          />
        </FormLabelComponent>

        <Grid item sm={12} md={6} lg={3} display='flex' justifyContent='space-between' alignItems='flex-end'>
          <ButtonComponent onClick={() => getData({ user_name: searchUser })} title='pesquisar' size='medium' margin='0px 10px 0px 0px' />

          <Modal title='Criar vinculo' NoReload={true} open={open === true} handleClick={() => addModal(!open)}>
            <Form initialValues={INITIAL_VALUES} loading={loadingAD} handleSubmitForm={registerUserStore} setLoading={setLoadingAD} setCanSave={setCanSave}>
              <ButtonFormFullWithLoading disabled={loadingAD || !canSave || saving ? true : false} loading={loadingAD} saving={saving} onClick={() => addModal(false)} />
            </Form>
          </Modal>
        </Grid>
      </Grid>

      <Modal open={!!openEdit} handleClick={() => addModalEdit(!openEdit)}>
        <Form initialValues={editData || INITIAL_VALUES} loading={loadingAD} handleSubmitForm={registerUserStore} setLoading={setLoadingAD} setCanSave={setCanSave}>
          <ButtonFormFullWithLoading disabled={loadingAD || !canSave || saving ? true : false} onClick={() => addModalEdit(false)} loading={loadingAD} saving={saving} />
        </Form>
      </Modal>

      <ModalDelete open={!!open && open !== true} handleClick={() => addModal(undefined)} onClickSubmit={handleClickDelete} title='Confirma a exclusão desse vinculo?' />
      <br />
      <br />
      <Table
        request={request}
        data={filterUserStore()}
        size={total}
        headCells={HEAD_CELL}
        page={pagination.page}
        onChangePage={handleChangePage}
        noActionView
        noActionEdit
        handleClickAction={handleClickAction}
        order={pagination.order === 1 ? 'asc' : 'desc'}
        orderBy={pagination.sort}
        onRequestSort={handleRequestSort}
      />
    </>
  );
};

export default UserStoreComponent;
